module.exports = __webpack_public_path__ + "src/assets/textures/env/hay/hay_alpha.png";